<template>
  <div class="root" :style="{ width: `${visibleResources.length * 21 + 1}px` }">
    <div
      v-for="resource in visibleResources"
      :key="resource.name"
      class="image-wrapper"
    >
      <ResourceImage
        :resource="resource"
        :class="`image ${resource.active ? 'bg-green' : 'bg-light2'}`"
        v-b-tooltip.hover="$t(`resource_${resource.name}`)"
      />
    </div>
  </div>
</template>

<script>
import ResourceImage from '@/elements/ResourceImage';
import config from '@/config';

export default {
  name: 'Resources',
  props: {
    showInactive: {
      default: false,
    },
    resources: {
      type: Array,
      default: function() {
        return [];
      },
    },
  },
  components: {
    ResourceImage,
  },
  computed: {
    visibleResources() {
      if (this.showInactive) {
        return config.availableResources.map(resource => ({
          name: resource,
          active: (this.resources || []).includes(resource),
        }));
      }

      return (this.resources || []).map(resource => ({
        name: resource,
        active: true,
      }));
    },
  },
};
</script>

<style scoped lang="scss">
.root {
  display: inline-block;
}

.image {
  height: 20px;
  width: 20px;
  line-height: 22px;
}

.image-wrapper {
  display: inline-block;

  &:not(:last-child) {
    margin-right: 1px;
  }
}
</style>



// WEBPACK FOOTER //
// src/elements/Resources.vue